function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	for (const el of document.querySelectorAll("a._archive_filter")) {
		el.addEventListener("click", () => {
			el.href = el.dataset.qs;
		});
	}
});
